export default __webpack_public_path__ + "static/media/fr-asia-10.6ef6bd66.jpg";